import Button from '../../components/buttons/Button';
import './NotFound.css';

function NotFound() {

    function toHome(){
        window.open('/', '_self');
    }

    return (
        <div className="notFound">
            <img src='../_assets/images/notFound.png' alt='Página não encontrada' />
            <Button icon='arrowLeft' text='Voltar' styled='primary' class='commonButton' onClick={toHome} />
        </div>
    );
}

export default NotFound;